// client/src/pages/Admin/ResourceManager/components/ResourceSkeleton.tsx

import React from 'react';
import { RefreshCw } from 'lucide-react';

export const ResourceSkeleton: React.FC = () => {
  return (
    <div className="loading-state" role="status" aria-label="Loading resources">
      <div className="loading-spinner-container">
        <RefreshCw size={40} className="loading-spinner" />
      </div>
      <p className="loading-text">Loading your resources...</p>
    </div>
  );
};